import * as React from 'react';
const SvgAction = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9.124 2a.75.75 0 0 1 .75.75v1.594a.75.75 0 0 1-1.5 0V2.75a.75.75 0 0 1 .75-.75m4.913 2.212a.75.75 0 0 1 0 1.06l-1.195 1.195a.75.75 0 1 1-1.06-1.06l1.194-1.195a.75.75 0 0 1 1.06 0m-9.825 0a.75.75 0 0 1 1.06 0l1.195 1.195a.75.75 0 0 1-1.06 1.06L4.212 5.272a.75.75 0 0 1 0-1.06m4.255 5.606c-.365-.933.555-1.852 1.487-1.488l7.452 2.912c.974.38.974 1.758 0 2.14l-2.794 1.093-1.094 2.795c-.381.974-1.759.973-2.14 0zm1.689.201 2.293 5.867.885-2.263a.75.75 0 0 1 .425-.425l2.264-.886zM2.75 8.374h1.594a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1 0-1.5m3.717 3.407a.75.75 0 0 1 0 1.06l-1.195 1.196a.75.75 0 0 1-1.06-1.06l1.195-1.196a.75.75 0 0 1 1.06 0"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgAction;
